import Vue from 'vue'
import VueRouter from 'vue-router'
import CashierCustomization from '@/pages/CashierCustomization.vue'
const Demo = () => import(/* webpackChunkName: "Demo" */ '@/pages/Demo.vue')
const UsagePage = () => import(/* webpackChunkName: "Usage", webpackPrefetch: true */ '@/pages/Usage.vue')
const Showcase = () => import(/* webpackChunkName: "Showcase", webpackPrefetch: true */ '@/pages/Showcase.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'configs'
  },
  {
    path: '/configs',
    name: 'CashierCustomization',
    component: CashierCustomization
  },
  {
    path: '/demo',
    name: 'Demo',
    component: Demo
  },
  {
    path: '/usage',
    name: 'Usage',
    component: UsagePage
  },
  {
    path: '/showcase',
    name: 'Showcase',
    component: Showcase
  }
]

const router = new VueRouter({
  base: '/cashier-config/',
  mode: 'history',
  routes
})

export default router
